export const TEAM_MEMBER_STATUS = {
  STATUS_REQUEST: 1,
  STATUS_ACTIVE: 2,
  STATUS_REJECTED: 3,
  STATUS_LEFT: 4,
  STATUS_EXCLUDED: 5,
};

export default {
  TEAM_MEMBER_STATUS,
};
